<div class="filter-wrapper">
	<div class="ob-grid filter-selection">
		<div class="filter-buttons ob-span-3">
			<div class="filter-button">
				<button
					mat-button
					obButton="secondary"
					(click)="toggleFilterVisibility()"
					[matTooltip]="(hideFilters ? 'i18n.button.show_filters' : 'i18n.button.hide_filters') | translate"
				>
					<mat-icon [svgIcon]="'filter'"></mat-icon>
					{{ "i18n.button.filters" | translate }}
				</button>
			</div>
		</div>
		@for (section of orderedKeys; track section) {
		<div class="ob-span-3" [hidden]="hideFilters">
			<app-filter-multiselect-dropdown
				[selectedOptionsFromFilter]="selectedValues[section]"
				[translationDropdownFieldName]="'i18n.filters.' + section.toLowerCase()"
				[dropdownOptions]="filters[section]"
				[section]="section"
				[displaySelectAllOption]="getDisplaySelectAllOption(section)"
				(changeEvent)="selectionChange(section, $event)"
			></app-filter-multiselect-dropdown>
		</div>
		}
	</div>

	<div class="filter-chips">
		<mat-chip-set>
			@for (section of orderedKeys; track section) { @for (selected of selectedValues[section]; track selected) {
			<mat-chip class="info" (removed)="onChipRemove(section, selected)" [removable]="true">
				{{ getFilterSection(section) }}
				{{ getFilterLabel(section, selected) }}
				<mat-icon [svgIcon]="'xmark_circle'" matChipRemove></mat-icon>
			</mat-chip>
			} } @if (hasSelectedFilters()) {
			<button mat-button [obButton]="'tertiary'" (click)="resetAllFilter()">
				<mat-icon [svgIcon]="'undo'"></mat-icon>
				{{ "i18n.button.reset_all_filters" | translate }}
			</button>
			}
		</mat-chip-set>
	</div>
</div>
